import React from "react";
import Navbar from "../components/Navbar";
import { BsTwitterX } from "react-icons/bs";
import { BsInstagram } from "react-icons/bs";
import { BsLinkedin } from "react-icons/bs";
import logo from "../assets/image 107.svg";
import { Link } from "react-router";

const Privacy = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div className="d-flex flex-column" style={{ backgroundColor: "#f7ebee" }}>
      <Navbar />
      <div className="privacy-top-margin container d-flex flex-column">
        <div className="d-flex flex-column">
          <span
            style={{
              fontSize: "48px",
              lineHeight: "62px",
              fontWeight: 400,
              color: "#CC2B52",
            }}
          >
            Privacy Policy
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            WE RESPECT YOUR PRIVACY
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            PatchUp (operated by PatchUp Technologies Private Limited) is
            committed to protecting your personal information and respecting
            your privacy. This Privacy Policy describes the personal information
            we collect, how we use it, and how we secure it. By accessing our
            services through our website or application ("Platform"), you agree
            to the terms of this Privacy Policy.
          </span>
        </div>

        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            INFORMATION WE COLLECT{" "}
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            We may collect the following types of personal information when you
            voluntarily provide it to us while using our services:
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            <ol>
              <li>User's name</li>
              <li>
                Email address (required for communication and login purposes)
              </li>
              <li>
                Phone number (used for account verification via OTP and support)
              </li>
              <li>
                Location (optional; only if shared by the user through
                permissions or input)
              </li>
              <li>Profile photo (optional for use as a profile picture)</li>
              <li>
                Preferences and activities (e.g., services you are interested
                in, compatibility tools you use, or feedback provided)
              </li>
              <li>
                Social media information (only if shared for specific services
                or integrations, such as sharing content on social media
                platforms).
              </li>
            </ol>
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            NON-PERSONALLY IDENTIFIABLE INFORMATION
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            We also collect non-personal information about your usage of the
            Platform. This may include:
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            <ul>
              <li>Operating system and browser type</li>
              <li>Device identifier and type </li>
              <li>Internet Protocol (IP) address </li>
              <li>Date and time of access</li>
              <li>Pages viewed and search queries</li>
              <li>
                Referring URLs (what website or link brought you to PatchUp)
              </li>
            </ul>
            Most of this information is collected via cookies or analytics
            tools.
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            HOW WE USE YOUR INFORMATION{" "}
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            The information collected is used to:
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            <ol>
              <li>
                Provide and personalize our services to better meet your needs.
              </li>
              <li>
                Facilitate account creation, login, and communication with you.{" "}
              </li>
              <li>Enable smooth booking and scheduling of services. </li>
              <li>
                Offer relevant recommendations and content based on your
                preferences.
              </li>
              <li>Improve the usability and effectiveness of the Platform.</li>
              <li>
                Communicate updates, promotions, or new features relevant to
                you.
              </li>
              <li>Prevent fraud and maintain the security of your account.</li>
              <li>
                Fulfill our legal obligations as required by applicable laws.{" "}
              </li>
            </ol>
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            SHARING YOUR INFORMATION{" "}
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            We will only share your information under the following
            circumstances:{" "}
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            <ol>
              <li>
                Service Providers: Information may be shared with third-party
                experts (such as counselors or relationship coaches) to deliver
                the services you request.{" "}
              </li>
              <li>
                Legal Obligations: Information may be disclosed if required by
                law, legal proceedings, or to respond to lawful requests from
                public authorities.{" "}
              </li>
              <li>Enable smooth booking and scheduling of services. </li>
              <li>
                Business Operations: We may share information with affiliated
                entities (e.g., parent companies or subsidiaries) under strict
                privacy controls.
              </li>
            </ol>
            We do not sell or rent your personal information to third parties
            for their marketing purposes.
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            COOKIES{" "}
          </span>

          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            PatchUp uses cookies and similar technologies to improve user
            experience, track preferences, and analyze traffic. You can manage
            your cookie preferences through your browser settings. However,
            disabling cookies may impact the functionality of certain features.
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            SECURITY{" "}
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            We take the security of your personal information seriously and
            implement industry-standard measures to protect it from unauthorized
            access, misuse, or disclosure. These include:
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            <ul>
              <li>Encryption of sensitive data during transmission.</li>
              <li>
                Access control measures to restrict access to personal
                information.
              </li>
              <li>Enable smooth booking and scheduling of services. </li>
              <li>Regular monitoring of our systems for vulnerabilities.</li>
            </ul>
            While we strive to protect your information, no system can guarantee
            complete security. By using our services, you acknowledge this risk.
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            DATA RETENTION{" "}
          </span>

          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            We retain your personal information only as long as necessary to
            fulfill the purposes outlined in this policy or as required by law.
            If you wish to delete your account or request the removal of
            specific data, please contact us at support@patchup.com.
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            YOUR CHOICES{" "}
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            You have the right to:
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            <ol>
              <li>
                Access and Update: Review or update the personal information
                you’ve shared with us.
              </li>
              <li>
                Withdraw Consent: Revoke consent to data processing where
                applicable.{" "}
              </li>
              <li>
                Delete Account: Request account deletion and associated data
                removal.{" "}
              </li>
            </ol>
            To exercise these rights, contact us at support@patchup.com.
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            CHANGES TO THIS POLICY{" "}
          </span>

          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            PatchUp reserves the right to modify this Privacy Policy at any
            time. Any significant changes will be communicated through the
            Platform or via email. Continued use of our services constitutes
            acceptance of the revised policy.
          </span>
        </div>
        <div className="d-flex flex-column">
          <span
            className="mt-3"
            style={{
              fontSize: "32px",
              lineHeight: "64px",
              fontWeight: 500,
              color: "#6E6E6E",
            }}
          >
            CONTACT US{" "}
          </span>

          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            If you have any questions about this Privacy Policy, or if you need
            support with privacy-related concerns, please reach out to us at:
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            If you have any questions about this Privacy Policy, or if you need
            support with privacy-related concerns, please reach out to us at:
          </span>
          <span
            className="mt-3"
            style={{
              fontSize: "18px",
              lineHeight: "36px",
              fontWeight: 400,
              color: "#6E6E6E",
            }}
          >
            PatchUp Technologies Private Limited
            <br />
            Email: support@patchup.com
            <br />
            City: Bangalore
          </span>
        </div>
      </div>
      <div className="mt-5 pt-5 container pb-3">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <img src={logo}></img>
          </div>
          <div className="d-flex gap-3">
            <BsTwitterX style={{ color: "#CC2B52" }} />
            <BsLinkedin style={{ color: "#CC2B52" }} />
            <BsInstagram style={{ color: "#CC2B52" }} />
          </div>
        </div>
        <hr></hr>
        <div className="d-flex justify-content-between">
          <div className="d-flex gap-3">
            <span
              style={{
                color: "#3B486E99",
                fontSize: "16px",
                fontWeight: "400",
                fontFamily: "DM Sans",
              }}
            >
              © Patchup 2025
            </span>
            <Link to={"/privacy-policy"} style={{ textDecoration: "none" }}>
              <span
                style={{
                  color: "#3B486E",
                  fontSize: "16px",
                  fontWeight: "600",
                  fontFamily: "DM Sans",
                }}
                onClick={scrollToTop}
              >
                Privacy Policy
              </span>
            </Link>
            <Link
              to={"/terms-and-conditions"}
              style={{ textDecoration: "none" }}
            >
              <span
                style={{
                  color: "#3B486E",
                  fontSize: "16px",
                  fontWeight: "600",
                  fontFamily: "DM Sans",
                }}
              >
                Terms of use
              </span>
            </Link>
          </div>
          <div>
            {" "}
            <span
              style={{
                color: "#3B486E",
                fontSize: "16px",
                fontWeight: "600",
                fontFamily: "DM Sans",
              }}
            >
              Support@patchup.com
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
